<template>
  <div>
    <div class="date-buttons">
      <button
        :class="{ active: selectedButton === 'today' }"
        class="date-button"
        @click="selectButton('today')"
      >
        Hoje
      </button>
      <button
        :class="{ active: selectedButton === 'last7Days' }"
        class="date-button"
        @click="selectButton('last7Days')"
      >
        Últimos 7 dias
      </button>
      <button
        :class="{ active: selectedButton === 'last30Days' }"
        class="date-button"
        @click="selectButton('last30Days')"
      >
        Últimos 30 dias
      </button>
      <button
        :class="{ active: selectedButton === 'last6Months' }"
        class="date-button"
        @click="selectButton('last6Months')"
      >
        Últimos 6 meses
      </button>
    </div>

    <div id="maps-content">
      <div id="mapes" class="mapes">&nbsp;</div>
    </div>

    <div class="white-panel">
      <img :src="`/camds.png`" class="w-10" style="display: inline-block; margin-left: 20px" />
      <strong style="font-size: 24px; display: inline-block; margin-top: 20px; margin-left: 10px">Camadas</strong>
      <p style="margin-left: 20px; margin-top: 20px">
        Clique nos marcadores para visualizar os indicadores no mapa.
      </p>

      <p style="margin-left: 20px; margin-top: 40px">DADOS DE SEGURANÇA PÚBLICA</p>
      <p style="margin-left: 20px; font-size: 13px; margin-top: 10px">MUNICIPAL</p>

      <div id="app" style="display: flex; flex-direction: column; margin-top: 20px; margin: 30px">
        <label style="margin-bottom: 10px">
          <input type="checkbox" />
          Sensação de Segurança </label><br />

        <label style="margin-bottom: 10px">
          <input type="checkbox" />
          Operações da Guarda Municipal </label><br />

        <label style="margin-bottom: 10px">
          <input type="checkbox" />
          Efetivo da Guarda Municipal </label><br />
        <label style="margin-bottom: 10px">
          <input v-model="checkedT3" type="checkbox" @change="filterMap" />
          Ocorrência </label><br />

        <p style="font-size: 13px; margin-top: 20px; margin-bottom: 20px">ESTADUAL/FEDERAL</p>

        <label style="margin-bottom: 20px">
          <input type="checkbox" />
          Unidades de Segurança </label><br />
        <label style="margin-bottom: 10px">
          <input type="checkbox" />
          Tipos de Ocorrência </label><br />

        <p style="margin-bottom: 30px; margin-top: 20px">ANÁLISE E PREDIÇÃO</p>
        <label style="margin-bottom: 10px">
          <input type="checkbox" />
          Potêncial de Risco </label><br />
        <label style="margin-bottom: 10px">
          <input type="checkbox" />
          Crimes por área </label><br />
        <button
          style="
            margin-top: 10px;
            border: 1px solid black;
            width: 200px;
            height: 30px;
            margin-left: auto;
            margin-right: auto;
          "
          @click="uncheckAll"
        >
          Desmarcar Todos
        </button>
      </div>
    </div>
    <button class="export-button">
      Exportar Dados
      <span class="icon">&#10148;</span>
    </button>
    <div class="search-boxs">
      <input type="text" placeholder="Buscar..." />
      <span class="icon">&#128269;</span>
    </div>

    <div class="accordion">
      <h2
        class="panel-title"
        style="font-size: 22px; font-weight: bold; margin-top: 60px; margin-bottom: 20px"
      >
        Lista de Insights <button class="green-button" @click="addNewAccordion">+</button>
      </h2>
      <div class="accordion-header" @click="toggleAccordion">
        <h2>Insights</h2>
        <span class="accordion-icon">{{ accordionOpen ? '-' : '+' }}</span>
      </div>
      <div v-show="accordionOpen" class="accordion-content">
        <div v-for="(insight, index) in insights" :key="index" class="input-section">
          <label for="insightTitle">Título do Insight</label>
          <input
            id="insightTitle"
            v-model="insight.title"
            type="text"
            placeholder="Digite o título do insight"
          />

          <p style="font-weight: bold; margin-top: 20px">Fale com o GPT</p>
          <textarea
            v-model="insight.message"
            placeholder="Digite sua mensagem..."
            style="height: 100px; overflow-y: auto"
          >&nbsp;</textarea>

          <p style="margin-top: 20px">Variáveis</p>
          <textarea v-model="insight.variables" style="height: 100px; overflow-y: auto">&nbsp;</textarea>
          <div class="button-group" style="margin-top: 20px">
            <button class="green-button" @click="saveAction(index)">Salvar</button>
            <button class="green-button" @click="cancelAction(index)">Cancelar</button>
            <button class="green-button" @click="confirmDeleteAction(index)">Excluir</button>
            <button class="green-button">Gerar Prompt</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Lista de novos acordeões adicionados -->
    <div v-for="(newAccordion, index) in newAccordions" :key="index">
      <div class="accordion">
        <div class="accordion-header" @click="toggleNewAccordion(index)">
          <h2>Insigth Teste</h2>
          <span class="accordion-icon">{{ newAccordionsOpen[index] ? '-' : '+' }}</span>
        </div>
        <div v-show="newAccordionsOpen[index]" class="accordion-content">
          <div v-for="(insight, index) in insights" :key="index" class="input-section">
            <label for="insightTitle">Título do Insight</label>
            <input
              :id="'insightTitle_' + index"
              v-model="insight.title"
              type="text"
              placeholder="Digite o título do insight"
            />

            <p style="font-weight: bold; margin-top: 20px">Fale com o GPT</p>
            <textarea
              v-model="insight.message"
              placeholder="Digite sua mensagem..."
              style="height: 100px; overflow-y: auto"
            >&nbsp;</textarea>

            <p style="margin-top: 20px">Variáveis</p>
            <textarea
              v-model="insight.variables"
              style="height: 100px; overflow-y: auto"
            >&nbsp;</textarea>
            <div class="button-group" style="margin-top: 20px">
              <button class="green-button" @click="saveAction(index)">Salvar</button>
              <button class="green-button" @click="cancelAction(index)">Cancelar</button>
              <button class="green-button" @click="confirmDeleteAction(index)">Excluir</button>
              <button class="green-button">Gerar Prompt</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from './Layout.vue'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import moment from 'moment'

export default {
  layout: Layout,
  props: {
    occurrences: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tela: 'mapes',
      selectedButton: 'today',
      selectedButton2: 'passado',
      uncheckAll: false,
      checkedT3: false,
      interval: ['now', '7days', '30days', '6months'],
      occurrencesToday: this.occurrences.filter(occ => occ.date == moment().format('YYYY-MM-DD')),
      occurrenceslast7Days: this.occurrences.filter(occ => moment(occ.date).format('YYYY-MM-DD') >= moment().subtract(7,'d').format('YYYY-MM-DD')),
      occurrenceslast30Days: this.occurrences.filter(occ => moment(occ.date).format('YYYY-MM-DD') >= moment().subtract(30,'d').format('YYYY-MM-DD')),
    }
  },
  mounted() {
    // Inicialização do mapa com vista mais ampla
    let mapes = L.map('mapes').setView([-8.0476, -34.877], 12) // Ajuste o nível de zoom conforme necessário

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(mapes)

    let customControl = L.control()

    customControl.onAdd = function () {
      let div = L.DomUtil.create('div', 'custom-control')
      div.style.textAlign = 'left'
      div.innerHTML = `
        <button class="map-button active">Passado</button>
        <button class="map-button">Tempo Real</button>
        <button class="map-button">Previsão</button>
      `
      return div
    }

    customControl.addTo(mapes)

    let mapIconControl = L.control({ position: 'bottomright' })

    mapIconControl.onAdd = function () {
      let container = L.DomUtil.create('div')

      let img = L.DomUtil.create('img', 'map-icon', container)
      img.src = 'icomap.png'
      img.style.width = '50px'
      img.style.cursor = 'pointer'

      let panel = L.DomUtil.create('div', 'map-style-panel', container)
      panel.style.display = 'none'
      panel.style.position = 'absolute'
      panel.style.bottom = '50px'
      panel.style.backgroundColor = 'white'
      panel.style.padding = '10px'
      panel.style.border = '1px solid #ccc'
      panel.style.height = '200px'
      panel.innerHTML = 'Detalhe do Mapa'

      L.DomEvent.on(img, 'click', function () {
        panel.style.display = panel.style.display === 'none' ? 'block' : 'none'
      })

      return container
    }

    mapIconControl.addTo(mapes)

    this.changeCheckbox('', mapes)
  },
  methods: {
    selectButton(button) {
      this.selectedButton = button
      this.filterMap()
    },
    selectButton2(button) {
      this.selectedButton2 = button
    },
    toggleAccordion() {
      this.accordionOpen = !this.accordionOpen
    },
    saveAction(index) {
      alert('Salvando o insight ' + (index + 1))
    },
    cancelAction(index) {
      alert('Cancelando o insight ' + (index + 1))
    },
    confirmDeleteAction(index) {
      if (window.confirm('Tem certeza que deseja excluir o Insight?')) {
        this.deleteAction(index)
        this.$set(this.newAccordionsOpen, index, false)
      }
    },
    deleteAction(index) {
      this.newAccordions.splice(index, 1)
    },
    toggleNewAccordion(index) {
      this.$set(this.newAccordionsOpen, index, !this.newAccordionsOpen[index])
    },
    addNewAccordion() {
      this.newAccordions.push({})
      this.newAccordionsOpen.push(false)
    },
    getIconClass(type) {
      switch (type) {
      case 'Homicidio/Tentativa':
        return 'icon-marker-1'
      case 'Tentativa/Roubo':
        return 'icon-marker-2'
      case 'Briga':
        return 'icon-marker-3'
      case 'Ação policial':
        return 'icon-marker-4'
      case 'Não identificado':
        return 'icon-marker-5'
      }
    },
    filterMap() {
      document.getElementById('maps-content').innerHTML = '<div id=\'mapes\'>&nbsp;</div>'
      let mapes = L.map('mapes').setView([-8.0476, -34.877], 12) // Ajuste o nível de zoom conforme necessário
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(mapes)

      // occurrenceslast7Days
      // occurrenceslast30Days
      // occurrenceslast6Months

      if(this.checkedT3) {
        if (this.selectedButton == 'today') {
          this.occurrencesToday.map((value) => {
            L.marker([value.lat, value.long], {icon: L.divIcon({className: this.getIconClass(value.type)})}).addTo(mapes)
          })
        } else if (this.selectedButton == 'last7Days') {
          this.occurrenceslast7Days.map((value) => {
            L.marker([value.lat, value.long], {icon: L.divIcon({className: this.getIconClass(value.type)})}).addTo(mapes)
          })
        } else if (this.selectedButton == 'last30Days') {
          this.occurrenceslast30Days.map((value) => {
            L.marker([value.lat, value.long], {icon: L.divIcon({className: this.getIconClass(value.type)})}).addTo(mapes)
          })
        } else if (this.selectedButton == 'last6Months') {
          this.occurrences.map((value) => {
            L.marker([value.lat, value.long], {icon: L.divIcon({className: this.getIconClass(value.type)})}).addTo(mapes)
          })
        }
      } else {
        let markers = L.markerClusterGroup()
        markers.clearLayers()
      }

      let customControl = L.control()

      customControl.onAdd = function () {
        let div = L.DomUtil.create('div', 'custom-control')
        div.style.textAlign = 'left'
        div.innerHTML = `
        <button class="map-button active">Passado</button>
        <button class="map-button">Tempo Real</button>
        <button class="map-button">Previsão</button>
      `
        return div
      }

      customControl.addTo(mapes)

      let mapIconControl = L.control({ position: 'bottomright' })

      mapIconControl.onAdd = function () {
        let container = L.DomUtil.create('div')

        let img = L.DomUtil.create('img', 'map-icon', container)
        img.src = 'icomap.png'
        img.style.width = '50px'
        img.style.cursor = 'pointer'

        let panel = L.DomUtil.create('div', 'map-style-panel', container)
        panel.style.display = 'none'
        panel.style.position = 'absolute'
        panel.style.bottom = '50px'
        panel.style.backgroundColor = 'white'
        panel.style.padding = '10px'
        panel.style.border = '1px solid #ccc'
        panel.style.height = '200px'
        panel.innerHTML = 'Detalhe do Mapa'

        L.DomEvent.on(img, 'click', function () {
          panel.style.display = panel.style.display === 'none' ? 'block' : 'none'
        })

        return container
      }

      mapIconControl.addTo(mapes)

      this.changeCheckbox('', mapes)
    },
  },
}
</script>

<style>
#mapes, #mapes-occurrences {
  width: 75%;
  height: 670px;
  float: right;
  margin-top: 60px;
}

.mapes.invisible {
  display: none;
}

/* .menu {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 10px;
  margin-right: 10px;
}

.menu button {
  margin-right: 50px;
  font-weight: bold;
} */

.date-button {
  background-color: rgba(217, 211, 211, 0.807);
  color: rgb(7, 7, 7);
  padding: 10px 20px;
  border: none;
  margin-right: 10px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 20px;
  margin-top: 20px;
}
.date-button:hover, .date-button.active {
  opacity: 0.9;
  background-color: #43b3ae;
  color: white;
}

.search-boxs {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 300px;
  height: 40px;
}
.search-boxs input[type='text'] {
  width: 100%;
  height: 100%;
  padding: 10px 20px 10px 40px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 10px;
}
.search-boxs .icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 20px;
  color: #e7e2e2;
}

.map-button {
  background-color: #f3e7e7;
  color: #000000;
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 10px;
}

.map-button:hover, .map-button.active {
  background-color: #ffffff;
  color: #000000;
}

.icon-marker-1 {
    display: block;
    width: 5px;
    height: 5px;
    background-color: rgb(209, 53, 43);
    border-radius: 100%;
    box-shadow: 0px 0px 0px 5px rgba(209, 53, 43, 0.3);
}

.icon-marker-2 {
    display: block;
    width: 5px;
    height: 5px;
    background-color: #52aba4;
    border-radius: 100%;
    box-shadow: 0px 0px 0px 5px rgba(82, 171, 164, 0.3);
}

.icon-marker-3 {
    display: block;
    width: 5px;
    height: 5px;
    background-color: #b98859;
    border-radius: 100%;
    box-shadow: 0px 0px 0px 5px rgba(185, 136, 89, 0.3);
}

.icon-marker-4 {
    display: block;
    width: 5px;
    height: 5px;
    background-color: rgb(23, 52, 207);
    border-radius: 100%;
    box-shadow: 0px 0px 0px 5px rgba(23, 52, 207, 0.3);
}

.icon-marker-5 {
    display: block;
    width: 5px;
    height: 5px;
    background-color: rgb(117, 117, 117);
    border-radius: 100%;
    box-shadow: 0px 0px 0px 5px rgba(117, 117, 117, 0.3);
}
.icon-marker-10 {
    display: block;
    width: 5px;
    height: 5px;
    background-color: blueviolet;
    border-radius: 100%;
    box-shadow: 0px 0px 0px 5px rgba(138, 43, 226, 0.3);
}
</style>
